import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';
import { SignedIn, SignedOut, UserButton, SignInButton } from "@clerk/clerk-react";
import logo from '../assets/branding/captionscript-logo.png';

export default function Navbar() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const isDashboard = location.pathname.startsWith('/dashboard');

  const uiLang = (i18n?.language || 'en').slice(0, 2);

  const signInLabels = {
    en: 'Sign In',
    pt: 'Entrar',
    de: 'Anmelden',
    fr: 'Se connecter',
    es: 'Iniciar sesión',
    it: 'Accedi',
  };

  const startLabels = {
    en: 'Start Free',
    pt: 'Começar grátis',
    de: 'Start frei',
    fr: 'Commencer gratuit',
    es: 'Empieza gratis',
    it: 'Inizia gratis',
  };

  const dashboardLabels = {
    en: 'Dashboard',
    pt: 'Dashboard',
    de: 'Dashboard',
    fr: 'Dashboard',
    es: 'Dashboard',
    it: 'Dashboard',
  };

  const signInText =
    t('landing.auth.signIn', { defaultValue: signInLabels[uiLang] || signInLabels.en });

  const startText =
    t('landing.cta.startShort', { defaultValue: startLabels[uiLang] || startLabels.en });

  const dashboardText =
    t('dashboard.common.dashboard', { defaultValue: dashboardLabels[uiLang] || dashboardLabels.en });

  const prefix = uiLang === 'en' ? '/' : `/${uiLang}`;

  return (
    <nav className="navbar">
      <Link to={prefix} className="nav-logo">
        <img src={logo} alt="CaptionScript" />
      </Link>

      <div className="nav-links">
        {!isDashboard && (
          <>
            <a href={`${prefix}#how`} className="nav-link">
              {t('landing.nav.how', { defaultValue: 'How it works' })}
            </a>
            <a href={`${prefix}#features`} className="nav-link">
              {t('landing.nav.features', { defaultValue: 'Features' })}
            </a>
            <a href={`${prefix}#pricing`} className="nav-link">
              {t('landing.nav.pricing', { defaultValue: 'Pricing' })}
            </a>
            <a href={`${prefix}#faq`} className="nav-link">
              {t('landing.nav.faq', { defaultValue: 'FAQ' })}
            </a>
          </>
        )}

        <LanguageSwitcher />

        <SignedOut>
          <div
            className="nav-auth-actions"
            style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}
          >
            <SignInButton mode="modal">
              <button
                type="button"
                className="btn-auth-secondary"
                style={{
                  background: 'transparent',
                  color: 'var(--text)',
                  border: '1px solid rgba(255,255,255,0.12)',
                  borderRadius: '999px',
                  padding: '0.75rem 1.2rem',
                  fontSize: '0.82rem',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  cursor: 'pointer',
                }}
              >
                {signInText}
              </button>
            </SignInButton>

            <SignInButton mode="modal">
              <button className="btn-auth-primary" type="button">
                {startText}
              </button>
            </SignInButton>
          </div>
        </SignedOut>

        <SignedIn>
          <div
            className="nav-auth-actions"
            style={{ display: 'flex', alignItems: 'center', gap: '0.85rem' }}
          >
            {!isDashboard && (
              <Link
                to="/dashboard"
                className="btn-auth-secondary"
                style={{
                  background: 'transparent',
                  color: 'var(--text)',
                  border: '1px solid rgba(255,255,255,0.12)',
                  borderRadius: '999px',
                  padding: '0.75rem 1.2rem',
                  fontSize: '0.82rem',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  textDecoration: 'none',
                }}
              >
                {dashboardText}
              </Link>
            )}

            <div className="nav-user">
              <UserButton afterSignOutUrl="/" />
            </div>
          </div>
        </SignedIn>
      </div>
    </nav>
  );
}